module.exports = __webpack_public_path__ + "static/media/sm.e0c7400d.png";